import React from 'react';
import PropTypes from 'prop-types';

// Config
import { crudConfig } from '../../../conf/securitySchemes';

// Components
import { MaterialIcon } from '../../../../components/MaterialIcon';
import { Dialog } from '../../../../components/Dialog';
import { DialogHeader } from '../../../../components/DialogHeader';
import { DialogBody } from '../../../../components/DialogBody';
import { DialogFooter } from '../../../../components/DialogFooter';
import { Button } from '../../../../components/Button';
import FeedbackCard from '../../../../components/FeedbackCard';

// Hooks
import { useDeleteScheme } from '../../api/hooks/useDeleteScheme';

export const DeleteScheme = ({ data, closeDialog, sessionToken }) => {
    const [wasSuccessful, setWasSuccessful] = React.useState(false);
    const deleteScheme = useDeleteScheme({
        crudConfig,
        sessionToken,
        onSuccessCb: () => {
            setFatalError(null);
            setWasSuccessful(true);
            setTimeout(() => {
                CloseDialog();
            }, 500);
        },
        onErrorCb: (e) => {
            setFatalError(e);
            setWasSuccessful(false);
        }
    });
    const [fatalError, setFatalError] = React.useState(null);
    const [deleteData, setDeleteData] = React.useState();

    React.useEffect(() => {
        if (!deleteData) {
            setDeleteData(data);
        }
    }, [data]);

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Delete = () => {
        deleteScheme.mutate(data.schemeId);
    };

    return (
        <div style={{ height: `30rem` }}>
            <Dialog close={CloseDialog} size="md" visible id="concept-determination-method-manager-delete">
                <DialogHeader close={CloseDialog}>{`Delete ${
                    deleteData?.schemeName ? deleteData?.schemeName : 'Scheme'
                }`}</DialogHeader>
                <DialogBody>
                    Are you sure you wish to delete this security scheme?
                    {fatalError != null && (
                        <FeedbackCard
                            intent={'danger'}
                            feedback={{
                                heading: `An error has occurred.`,
                                message: `Please wait a few moments before trying your request
        again.`
                            }}
                            details={fatalError}
                        />
                    )}
                </DialogBody>
                <DialogFooter>
                    {deleteScheme.isLoading && <div style={{ marginRight: '0.5rem' }}>Loading...</div>}
                    {!deleteScheme.isLoading && wasSuccessful && (
                        <div style={{ marginRight: '0.5rem' }}>
                            <MaterialIcon icon={'done_outline'} color={'#04846D'} />
                        </div>
                    )}
                    <Button appearance="primary" text onClick={Delete} disabled={deleteScheme.isLoading}>
                        Delete
                    </Button>
                    <Button appearance="secondary" text onClick={CloseDialog}>
                        Cancel
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

DeleteScheme.propTypes = {
    sessionToken: PropTypes.string.isRequired,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired
};

export default DeleteScheme;
